export async function compressImage(file, optionsOrMaxWidth = {}, legacyMaxHeight, legacyQuality) {
  // Soporta dos formas de llamada para no romper los callers existentes:
  //   compressImage(file, { maxWidth, maxHeight, quality, mimeType })
  //   compressImage(file, maxWidth, maxHeight, quality)          // legacy
  const options =
    typeof optionsOrMaxWidth === 'object' && optionsOrMaxWidth !== null
      ? optionsOrMaxWidth
      : { maxWidth: optionsOrMaxWidth, maxHeight: legacyMaxHeight, quality: legacyQuality };

  const {
    maxWidth = 1280,
    maxHeight = 1280,
    quality: finalQuality = 0.72,
    mimeType = 'image/jpeg',
  } = options;

  if (!file) return null;
  if (!file.type || !file.type.startsWith('image/')) {
    return await fileToBase64(file);
  }

  const imgBitmap = await createImageBitmap(file);
  let { width, height } = imgBitmap;

  if (width > maxWidth || height > maxHeight) {
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(imgBitmap, 0, 0, width, height);
  imgBitmap.close?.();

  return canvas.toDataURL(mimeType, finalQuality);
}

export function compressAvatar(file) {
  return compressImage(file, { maxWidth: 512, maxHeight: 512, quality: 0.75 });
}

export function compressDocument(file) {
  return compressImage(file, { maxWidth: 1600, maxHeight: 1600, quality: 0.78 });
}

function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
